export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9012.75c9a8e8.jpg";